import api from "./api"

export const getDeliveryTripFormData = async () => {
  const response = await api.get("/delivery-trips/form-data")
  return response.data
}

export const getDeliveryTrips = async (params = {}) => {
  const response = await api.get("/delivery-trips", { params })
  return response.data
}

export const getDeliveryTripById = async (tripId) => {
  const response = await api.get(`/delivery-trips/${tripId}`)
  return response.data
}

export const createDeliveryTrip = async (payload) => {
  const response = await api.post("/delivery-trips", payload)
  return response.data
}

export const startDeliveryTrip = async (tripId, payload = {}) => {
  const response = await api.post(`/delivery-trips/${tripId}/start`, payload)
  return response.data
}

export const deliverTripStop = async (tripId, stopId, payload = {}) => {
  const response = await api.post(
    `/delivery-trips/${tripId}/stops/${stopId}/deliver`,
    payload
  )
  return response.data
}

export const completeDeliveryTrip = async (tripId, payload = {}) => {
  const response = await api.post(`/delivery-trips/${tripId}/complete`, payload)
  return response.data
}

export const returnDeliveryTrip = async (tripId, payload = {}) => {
  const response = await api.post(`/delivery-trips/${tripId}/return`, payload)
  return response.data
}

export const cancelDeliveryTrip = async (tripId, payload = {}) => {
  const response = await api.post(`/delivery-trips/${tripId}/cancel`, payload)
  return response.data
}